export default "__VITE_PUBLIC_ASSET__d9a2ea71__"